<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">

              <div class="row">
                <div class="form-group col-sm-12">
                  <ul class="navbar-nav overflow-auto flex-row gap-4" >
                    <li v-for="(value, tab) in Tabs" :key="tab" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                      <a href="#" @click.prevent="selectTab(tab)" class="nav-link tab" :class="{'active': activeTabName === tab}">{{ helper.trans(`users.tab.${tab}`) }}</a>
                    </li>
                  </ul>
                </div>
              </div>

              <LoaderWrapper ref="summaryLoader" class="h-100" >
                <div class="d-flex" style="column-gap: 3em" v-if="isAdmin">
                  <div v-for="account in summary" class="mt-2">
                    <div class="row">
                      <AccountWidget show-icon hide-insurance :account="account"></AccountWidget>
                    </div>
                  </div>
                </div>
              </LoaderWrapper>

            </div>
          </div>

          <SystemAccounts v-if="activeTabName === Tabs.system"></SystemAccounts>
          <Traders type="traders" v-if="activeTabName === Tabs.traders"></Traders>
          <Traders type="providers" v-if="activeTabName === Tabs.providers"></Traders>
          <Merchants v-if="activeTabName === Tabs.merchants"></Merchants>
          <MerchantOperators v-if="activeTabName === Tabs.merchantOperators"></MerchantOperators>
          <TraderOperators v-if="activeTabName === Tabs.traderOperators"></TraderOperators>
          <Users :role="UserRole.OPERATOR" v-if="activeTabName === Tabs.operators"></Users>
          <Users :role="UserRole.TRADER_TEAM_LEAD" v-if="activeTabName === Tabs.teamleads"></Users>
          <Users :role="UserRole.REFERRAL" v-if="activeTabName === Tabs.referrals"></Users>
          <Users :role="UserRole.ADMIN" v-if="activeTabName === Tabs.admins"></Users>

        </div>
      </div>
    </div>


    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import Traders from "@/components/users/Traders.vue";
import Merchants from "@/components/users/Merchants.vue";
import Users from "@/components/users/Users.vue";
import {UserRole} from "@/models/enum/UserRole";
import {useRoute} from "vue-router";
import router from "@/router";
import AccountWidget from "@/components/AccountWidget.vue";
import AccountDTO from "@/models/AccountDTO";
import SystemAccounts from "@/components/SystemAccounts.vue";
import MerchantOperators from "@/components/users/MerchantOperators.vue";
import TraderOperators from "@/components/users/TraderOperators.vue";

const api = new APIClient();
const notification = useNotification()

enum Tabs {
  traders = 'traders',
  providers = 'providers',
  teamleads = 'teamleads',
  merchants = 'merchants',
  merchantOperators = 'merchantOperators',
  traderOperators = 'traderOperators',
  referrals = 'referrals',
  operators = 'operators',
  admins = 'admins',
  system = 'system'
}

export default defineComponent({
  components: {
    TraderOperators,
    MerchantOperators,
    SystemAccounts,
    AccountWidget,
    LoaderWrapper,
    ConfirmModal,
    CopyButton,
    BPagination,
    Traders,
    Merchants,
    Users
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const summaryLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const confirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)


    const state = reactive({
      activeTabName: (route.params.type ?? Tabs.traders) as Tabs,
      summary: [] as AccountDTO[],
    });

    const selectTab = async (tab: Tabs, page: number|null = 1,  id: any = null) => {
      if (id) {
        router.push({path: `/admin/users/${tab}/${id}`, query: {page: page}})
      } else {
        router.push({path: `/admin/users/${tab}`, query: {page: page}})
      }

      state.activeTabName = tab

      if (store.getters.isAdmin) {
        summaryLoader.value?.show()
        try {
          switch (tab) {
            case Tabs.traders:
              state.summary = await api.traderAccountsSummary();
              break;
            case Tabs.providers:
              state.summary = await api.traderAccountsSummary({onlyWithOperators: true});
              break;
            case Tabs.merchants:
              state.summary = await api.merchantStoreAccountsSummary();
              break;
            case Tabs.system:
              state.summary = await api.systemAccountsSummary();
              break;
            case Tabs.referrals:
              state.summary = await api.userAccountsSummary({userRole: UserRole.REFERRAL});
              break;
            case Tabs.teamleads:
              state.summary = await api.userAccountsSummary({userRole: UserRole.TRADER_TEAM_LEAD});
              break;
            default:
              state.summary = [];
              break;
          }
        } finally {
          summaryLoader.value?.hide()
        }
      }
    }


    onMounted(() => {
      const tab = (route.params.type ?? '') as string
      selectTab(((Object.values(Tabs) as string[]).includes(tab) ? tab : Tabs.traders) as Tabs, route.query.page as any, route.params.id)
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.getUser?.role === UserRole.OPERATOR),
      loader,
      dateHelper,
      numberFormatter,
      confirmModal,
      Tabs,
      selectTab,
      helper,
      UserRole,
      summaryLoader
    }
  }
})
</script>
